/**
 * return proficiency tooltip content
 * @return {JSX}
 */
export const proficiencyTooltipContent = (
  <>
    <p>
      <strong>Beginner</strong> Limited to no knowledge of panel data.
    </p>
    <br />
    <p>
      <strong>Intermediate</strong> Understands data methodology, what is panel data and <br />
      difference between other data sets like POS.
    </p>
    <br />
    <p>
      <strong>Advanced</strong> In-depth knowledge of panel methodology and nuances of panel
      <br /> & POS metrics and formulas.
    </p>
  </>
);
